<template>
  <ValidationObserver ref="observer" tag="form">
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <div id="tao-group">
            <div class="row">
              <div class="col col-6">
                <ValidationProvider
                  name="Mã nhóm người dùng"
                  rules="required|maxlength:50|code|hashcode"
                  v-slot="validationContext"
                >
                  <b-form-group
                    label-class="required font-weight-bold"
                    label="Mã nhóm người dùng"
                    label-for="code"
                  >
                    <b-form-input
                      id="code"
                      :state="getValidationState(validationContext)"
                      v-model="internalForm.code"
                      type="text"
                      required
                      :readonly="readonly"
                      placeholder=""
                    />
                    <b-form-invalid-feedback
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col col-6">
                <ValidationProvider
                  name="Tên nhóm người dùng"
                  rules="required|maxlength:50"
                  v-slot="validationContext"
                >
                  <b-form-group
                    label-class="required font-weight-bold"
                    label="Tên nhóm người dùng"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      v-model="internalForm.name"
                      :state="getValidationState(validationContext)"
                      type="text"
                      required
                      :readonly="readonly"
                      placeholder=""
                    />
                    <b-form-invalid-feedback
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group></ValidationProvider
                >
              </div>
              <div class="col col-12">
                <b-form-group
                  label="Mô tả"
                  label-for="description"
                  class="required"
                  label-class=" font-weight-bold"
                >
                  <ValidationProvider
                    name="Mô tả"
                    rules="required|maxlength:255"
                  >
                    <div slot-scope="{ errors }">
                      <b-form-textarea
                        id="displayName"
                        v-model="internalForm.description"
                        type="text"
                        placeholder=""
                        :readonly="readonly"
                        rows="2"
                        max-rows="100"
                        no-resize
                        :class="{ 'is-danger-box': errors.length > 0 }"
                        class="overflow-y-hidden"
                      />
                      <p :class="{ error: errors.length > 0 }">
                        {{ errors[0] }}
                      </p>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col col-12">
                <b-form-group
                  label-class="required font-weight-bold"
                  label="Ứng dụng"
                  label-for="name"
                >
                  <ValidationProvider
                    name="Ứng dụng"
                    rules="requiredMultiple"
                    v-slot="validationContext"
                  >
                    <MultiSelect
                      :options="danhSachApp"
                      optionLabel="name"
                      optionValue="id"
                      class="w-100"
                      placeholder="Chọn ứng dụng"
                      :state="getValidationState(validationContext)"
                      :class="{
                        'select-invalid is-invalid':
                          validationContext.errors.length > 0,
                      }"
                      :disabled="readonly"
                      v-model="internalForm.applicationIds"
                      display="chip"
                    ></MultiSelect>
                    <b-form-invalid-feedback
                      :force-show="
                        validationContext.invalid && validationContext.validated
                      "
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import { BANG_PHAM_VI_GROUP } from "@/constants/constants";

export default {
  name: "TaoGroup",
  data() {
    return {
      internalForm: {
        code: "",
        name: "",
        description: "",
        appId: null,
        applicationIds: [],
        lstPermission: [],
        lstRole: [],
        lstUserInGroup: [],
        parentId: null,
        chucVuId: null,
        lstPhamVi: [],
        lstArea: [],
      },
      optionsDonVi: [],
      reloadDonVi: false,
      danhSachPhamVi: [],
      danhSachPhamViNoiBo: [],
      isLoadingTable: false,
      fieldName: [
        { key: "checkbox", label: "" },
        { key: "name", label: "Tên phạm vi" },
      ],
      selectAllRowsInPage: false,
      danhSachIdPhamVi: [],
      danhSachIdPhamViDaChon: [],
      emptyHeaderTable: [BANG_PHAM_VI_GROUP.name],
      selectedPhamVi: [],
    };
  },
  props: {
    form: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Object | null,
      required: false,
    },
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/tatCaApp",
      danhSachChucVu: "chucVu/danhSachChucVu",
      danhSachDonVi: "donVi/danhSachDonVi",
      appId: "common/appId",
      danhSachGroupPaging: "group/danhSachGroupPaging",
    }),
    hasPhamViPageData() {
      return !_isEmpty(this.danhSachPhamViNoiBo);
    },
    phamViLabel() {
      return this.readonly ? "Phạm vi" : "Chọn phạm vi";
    },
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
  },
  async created() {
    this.layDanhSachApp();
    this.layDanhSachChucVu();
    this.layDanhSachDonViCha();
    this.layDanhSachGroupPaging();
  },
  watch: {
    appId: {
      handler() {
        if (!this.readonly) {
          this.internalForm.appId = this.appId;
        }
      },
    },
    form: {
      handler() {
        if (this.$route.params.id === "tao-moi") {
          this.internalForm = {
            code: "",
            name: "",
            description: "",
            appId: null,
            applicationIds: [],
            lstPermission: [],
            lstRole: [],
            lstUserInGroup: [],
            parentId: null,
            chucVuId: null,
            lstPhamVi: [],
            lstArea: [],
          };
          this.internalForm.appId = this.appId;
        } else {
          this.internalForm = Object.assign({}, this.internalForm, this.form);
          if (this.form) {
            this.internalForm.lstRole = (this.form.lstRole || []).map(
              (item) => item.roleId
            );
            this.internalForm.lstPermission = (
              this.form.lstPermission || []
            ).map((item) => item.permissionId);
            this.internalForm.lstUserInGroup = (
              this.form.lstUserInGroup || []
            ).map((item) => item.userId);
            this.internalForm.lstArea = (this.form.lstArea || []).map(
              (item) => item.areaId
            );
            this.internalForm.parentId = (this.form || {}).parentId;
            this.internalForm.chucVuId = (this.form || {}).chucVuId;
          }
        }
      },
      immediate: true,
    },
    "internalForm.parentId": {
      handler() {
        if (this.internalForm && this.internalForm.parentId) {
          this.layDanhSachPhamVi(this.internalForm.parentId);
        } else {
          this.danhSachPhamViNoiBo = [];
        }
      },
      deep: true,
    },
    danhSachPhamViNoiBo: {
      handler() {
        if (this.danhSachPhamViNoiBo && this.danhSachPhamViNoiBo.length) {
          if (!this.readonly) {
            this.selectedPhamVi = this.danhSachPhamViNoiBo.filter((x) =>
              this.internalForm.lstArea.includes(x.id)
            );
          }
        }
      },
      deep: true,
    },
    selectedPhamVi: {
      handler() {
        this.internalForm.lstArea = this.selectedPhamVi.map((x) => x.id);
      },
      deep: true,
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowInPage();
      },
    },
  },
  methods: {
    layDanhSachGroupPaging() {
      const payload = {
        appId: this.internalForm.appId,
        pageIndex: 1,
        pageSize: 50,
      };
      this.$store.dispatch("group/danhSachGroupPaging", payload);
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
    getFieldName() {
      if (this.readonly) {
        return this.fieldName.filter((x) => x.key !== "checkbox");
      } else {
        return this.fieldName;
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInternalForm() {
      return this.internalForm;
    },
    lamMoi() {
      this.internalForm = {
        code: "",
        name: "",
        description: "",
        appId: null,
        applicationIds: [],
        lstPermission: [],
        lstRole: [],
        lstUserInGroup: [],
        parentId: null,
        chucVuId: null,
        lstPhamVi: [],
        lstArea: [],
      };
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    layDanhSachChucVu() {
      this.$store.dispatch("chucVu/layDanhSachChucVu");
    },
    selectClass(valid) {
      return {
        "select-invalid": valid,
      };
    },
    treeselectClass(valid) {
      return {
        "treeselect-invalid": valid,
      };
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children,
      };
    },
    layDanhSachPhamVi(donViConId) {
      this.isLoadingTable = true;
      return this.$store
        .dispatch("donVi/layDanhSachPhamVi", {
          donViConId: donViConId,
        })
        .then((res) => {
          this.danhSachPhamVi = res.data.data;
          this.danhSachIdPhamVi = this.layDanhSachIdPhamVi();
          this.danhSachPhamViNoiBo = this.layDanhSachPhamViNoiBo();
          this.isLoadingTable = false;
        })
        .catch(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachPhamViNoiBo() {
      if (this.readonly) {
        if (!_isEmpty(this.danhSachPhamVi)) {
          this.selectedPhamVi = [];
          return this.danhSachPhamVi
            .filter((x) => this.internalForm.lstArea.includes(x.id))
            .map((phamVi) => {
              return {
                checkbox: null,
                id: _isNil(phamVi) ? "" : phamVi.id,
                name: _isNil(phamVi) ? "" : phamVi.tenDonVi,
              };
            });
        } else {
          return [];
        }
      } else {
        if (!_isEmpty(this.danhSachPhamVi)) {
          return this.danhSachPhamVi.map((phamVi) => {
            return {
              checkbox: null,
              id: _isNil(phamVi) ? "" : phamVi.id,
              name: _isNil(phamVi) ? "" : phamVi.tenDonVi,
            };
          });
        } else {
          return [];
        }
      }
    },
    layDanhSachIdPhamVi() {
      if (!_isEmpty(this.danhSachPhamVi)) {
        return this.danhSachPhamVi.map((phamVi) => phamVi.id);
      }
    },
    layDanhSachDonViCha() {
      this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
    },
  },
};
</script>

<style lang="scss">
.custom-control-label::after {
  content: "" !important;
}
.is-danger-box {
  border: solid 1px red;
}
.error {
  color: #dc3545;
  font-size: 11.2px;
  margin-top: 5px;
}
</style>
